import { ShieldCheck } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/shared/ui/tooltip';

/**
 * Marca, na listagem, o documento cujo PDF saiu assinado digitalmente (PAdES).
 *
 * Só aparece com `assinaturaDigital` do servidor — nunca deduzido do perfil
 * atual do médico: o documento de ontem foi assinado com o certificado que
 * valia ontem, e o selo fala do arquivo, não da configuração de hoje.
 *
 * ⚠️ `TooltipProvider` próprio, pelo motivo registrado em
 * `AnaliseComparativaPage`: não existe provider global, e o Radix lança sem ele.
 */
export function SeloDeAssinaturaDigital() {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="inline-flex align-middle ml-1.5 text-emerald-600"
            aria-label="Assinado digitalmente"
          >
            <ShieldCheck className="w-4 h-4" />
          </span>
        </TooltipTrigger>
        <TooltipContent>Assinado digitalmente — confira em validar.iti.gov.br</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
